<div class="quiz-result">
  <div class="result-flash" [class.correct]="isCorrect" [class.incorrect]="!isCorrect">
    <span class="result-icon">{{ isCorrect ? '&#10004;' : '&#10008;' }}</span>
    <span class="result-text">{{ isCorrect ? (currLang === 'ar' ? 'صحيح!' : 'Correct!') : (currLang === 'ar' ? 'خطأ' : 'Incorrect') }}</span>
    <span class="result-xp" *ngIf="isCorrect && xpEarned > 0">+{{ xpEarned | arabicNumber:currLang }} XP</span>
    <span class="correct-answer-text" *ngIf="!isCorrect">
      {{ currLang === 'ar' ? 'الإجابة الصحيحة:' : 'Correct answer:' }}
      {{ getOptionLabel(question?.correctOptionId) }} - {{ getCorrectAnswerText() }}
    </span>
  </div>
</div>
